import ToggleDirections from '../../../../../common/ToggleDirections';
import { isInSchoolAPHybridEvent } from '../../../../../../../utils/event';
import { useStateValue } from '../../../../../../../context/AppContext';

function MonitorStudentDirectionsAP() {
  const { orgEvent } = useStateValue();
  return (
    <ToggleDirections showDirectionInfo={true}>
      <div className='cb-white-bg'>
        <h3 className='tdtk-h3 how-to-Monitor-Testing'>How to Monitor Testing</h3>
        <div className='row px-0 mx-0 py-3 cb-border-top' role='region' aria-label='directions'>
          <div className='col-md-4 cb-margin-sm-down-bottom-16'>
            <h4 className='cb-paragraph6-st'>Reminders</h4>
            <ul className='pl-4 ml-2'>
              <li>Walk around every 10&ndash;15 minutes.</li>
              <li>Make sure laptops are open and tablets are uncovered.</li>
              <li>Make sure students resume testing after breaks.</li>
              <li>Watch for raised hands.</li>
              <li>Minimize distractions.</li>
            </ul>
          </div>
          <div className='col-md-4 cb-margin-sm-down-bottom-16'>
            <h4 className='cb-paragraph6-st'>Tips</h4>
            <ul className='pl-4 ml-2'>
              {isInSchoolAPHybridEvent(orgEvent) ? (
                <>
                  <li>Offline devices can’t send updates, so some student statuses could be inaccurate.</li>
                  <li>No action is required if students are testing smoothly.</li>
                  <li>
                    Technical issues are usually fixed by exiting and restarting Bluebook or restarting the device.
                  </li>
                  <li>
                    A dark blue Congratulations screen means that a student’s answers were submitted; their booklet
                    should be closed.
                  </li>
                </>
              ) : (
                <>
                  <li>Offline devices can’t send updates, so some student statuses could be inaccurate.</li>
                  <li>No action is required if students are testing smoothly.</li>
                  <li>
                    Technical issues are usually fixed by exiting and restarting Bluebook or restarting the device.
                  </li>
                  <li>A dark blue Congratulations screen means that a student’s answers were submitted.</li>
                </>
              )}
            </ul>
          </div>
          <div className='col-md-4'>
            <h4 className='cb-paragraph6-st'>Digital Security Violations</h4>
            <ul className='pl-4 ml-2'>
              <li>Viewing nontest content or using other applications.</li>
              <li>Trying to record or share test content in any way.</li>
              <li>Working on another student&rsquo;s device.</li>
              <li>Angling a device so another student can see it.</li>
              {isInSchoolAPHybridEvent(orgEvent) && <li>Writing in their booklet after time is up.</li>}
            </ul>
          </div>
        </div>
      </div>
    </ToggleDirections>
  );
}

export default MonitorStudentDirectionsAP;
